import styled from 'styled-components';
import { useState } from 'react';
import { Icon } from '@iconify/react';

// Components
import DefaultField from '../../../../components/common/DefaultField';
import CommonButton from '../../../../components/common/CommonButton';

// Formik
import { Form } from 'formik';

// Redux
import { changePasswordLogged } from '../../../../redux/api/auth';
import GenericSnackbar from '../../../../components/common/GenericSnackbar';

const PasswordManagement = (props) => {
    const { values, setFieldValue } = props;

    const [sending, setSending] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    // const [openSnackbar] = useSnackbar(optionsStyle);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarContent, setSnackbarContent] = useState({
        message: '',
        severity: 'success',
    });

    const toggleShowPassword = () => {
        console.log('toque');
        setShowPassword(!showPassword);
    };
    const toggleShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleSnackBar = (message, severity) => {
        setSnackbarContent({
            message: message,
            severity: severity,
        });
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
        setSnackbarContent({
            message: '',
            severity: 'success',
        });
    };

    const handleChangePassword = async (e) => {
        e.preventDefault();
        if (values.new_password_modal === values.confirm_new_password) {
            if (values.confirm_new_password.length > 7) {
                try {
                    setSending(true);
                    await changePasswordLogged(
                        values.personal_email,
                        values.confirm_new_password
                    );
                    setSending(false);
                    handleSnackBar(
                        'Se cambió la contraseña correctamente',
                        'success'
                    );
                    setOpenSnackbar(true);
                } catch (e) {
                    console.log('Error: ', e);
                    setSending(false);
                    handleSnackBar(
                        'Ocurrió un error al modificar la contraseña',
                        'error'
                    );
                    setOpenSnackbar(true);
                }
            }
        }
        setFieldValue('new_password_modal', '');
        setFieldValue('confirm_new_password', '');
    };

    return (
        <>
            <GenericSnackbar
                open={openSnackbar}
                message={snackbarContent.message}
                severity={snackbarContent.severity}
                handleClose={handleCloseSnackbar}
            />
            <PasswordManagementContainer>
                <h2>Cambiar contraseña</h2>
                <Container>
                    <FormContainer>
                        <Row>
                            <DefaultField
                                name="new_password_modal"
                                type={showPassword ? 'text' : 'password'}
                                label="Nueva contraseña"
                                value={values.new_password_modal}
                                setFieldValue={setFieldValue}
                            />
                            <ButtonPass onClick={toggleShowPassword}>
                                <Icon
                                    icon={
                                        showPassword ? 'mdi:eye' : 'mdi:eye-off'
                                    }
                                    width="24"
                                    height="24"
                                />{' '}
                            </ButtonPass>
                        </Row>
                        <Row>
                            <DefaultField
                                name="confirm_new_password"
                                type={showConfirmPassword ? 'text' : 'password'}
                                label="Repetir nueva contraseña"
                                value={values.confirm_new_password}
                                setFieldValue={setFieldValue}
                            />
                            <ButtonPass onClick={toggleShowConfirmPassword}>
                                <Icon
                                    icon={
                                        showConfirmPassword
                                            ? 'mdi:eye'
                                            : 'mdi:eye-off'
                                    }
                                    width="24"
                                    height="24"
                                />
                            </ButtonPass>
                        </Row>
                        <CommonButton
                            variant="outlined"
                            label={sending ? 'Enviando...' : 'Confirmar'}
                            onClick={handleChangePassword}
                        />
                    </FormContainer>
                </Container>
            </PasswordManagementContainer>
        </>
    );
};

export default PasswordManagement;

const PasswordManagementContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 1rem;

    h2 {
        color: #b31d15;
        font-size: 24px;
        font-weight: 700;
    }
`;

const Container = styled.div`
    width: 100%;
    max-height: 30vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    overflow-x: hidden;
`;

const FormContainer = styled(Form)`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 8rem;
    row-gap: 1rem;

    @media (width < 768px) {
        grid-template-columns: 1fr;
        row-gap: 1rem;
    }
`;

const ButtonPass = styled.div`
    background: none;
    // border: solid 1px red;
    cursor: pointer;
    color: #ccc;
    &:hover {
        color: #000;
    }
`;

const Row = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;
